import { FavoritesAssignWidgetContainer } from '@cian/favorites-assign-widget';
import { useSelector } from 'react-redux';

import { FavoritesFolders } from 'shared/components/FavoritesFolders';
import { selectIsAuthenticated } from 'shared/slices';

export function FavoritesFoldersContainer() {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const handleLogin = () => {
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup('favorites');
    }
  };

  // onCreateFolder, onSaveOffer, onClickFolderName, onNotificationSaveToFolder, onNotificationChangeFolder - нужны для аналитики

  return (
    <FavoritesFolders>
      <FavoritesAssignWidgetContainer
        isAuthenticated={isAuthenticated}
        disableNotification={true}
        // onCreateFolder={handleCreate}
        // onSaveOffer={handleSave}
        onWaitForLogin={handleLogin}
        // onClickFolderName={handleClickFolderName}
        // onNotificationSaveToFolder={handleSaveToFolder}
        // onNotificationChangeFolder={handleChangeFolder}
      />
    </FavoritesFolders>
  );
}
